import React from 'react';

import {PAGE_TYPE_FREE_TOPIC} from '@udemy/browse-utils';
import type {DiscoveryUnit} from '@udemy/discovery-api';

import {filterFreeTopicDiscoveryUnit} from '../free-topic.react-component';
import {useTopicRecommendations} from '../hooks/use-topic-recommendations';
import {
    FreeTopicDiscoveryUnitsContainerWrapper,
    TopicDiscoveryUnitsContainerWrapperLoader,
} from './topic-discovery-units-wrapper.react-component';

import type {Topic} from '../types/topic';

export interface FreeTopicDiscoverySectionProps {
    topic: Topic;
    isMobile: boolean;
    children?: React.ReactNode;
}

export const FreeTopicDiscoverySection = ({
    topic,
    isMobile,
    children,
}: FreeTopicDiscoverySectionProps) => {
    const {units, isLoading, onLoadMore} = useTopicRecommendations({
        topicId: topic.id,
        pageType: PAGE_TYPE_FREE_TOPIC,
        shouldFetchBundle: false,
    });

    if (isLoading) {
        return <TopicDiscoveryUnitsContainerWrapperLoader isMobile={isMobile} />;
    }

    return (
        <FreeTopicDiscoveryUnitsContainerWrapper
            topic={topic}
            isMobile={isMobile}
            pageType={PAGE_TYPE_FREE_TOPIC}
            discoveryUnitFilter={filterFreeTopicDiscoveryUnit}
            units={units as DiscoveryUnit[]}
            onLoadMore={onLoadMore}
            disableInfiniteScroll
        >
            {children}
        </FreeTopicDiscoveryUnitsContainerWrapper>
    );
};
